/**
 * @author        denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright     Copyright (c) 2022, Zumper
 */

import { selectMessageListingDetails } from '@zcode-ui/perm-address'
import { selectIsMobile } from '@zcode-ui/web-zumper-global-state'
import { hocCompose } from '@zcode/react-utils'
import { routerConnect } from '@zcode/router-connect'
import type { State } from '@zcode/state-type'
import { connect } from 'react-redux'
import type { RouteComponentProps } from 'react-router-dom'

import { default as StickyForm } from '../../../components/detail/StickyForm/StickyForm'
import { isMessaged } from '../../../inspectors/index'
import { selectFilterBedroom } from '../../../modules/filters/selectors/index'

export const mapRouteToProps = (routeProps: RouteComponentProps) => ({})

export const mapStateToProps = (state: State) => {
  const listingDetails = selectMessageListingDetails(state)
  const bedroomFilters = selectFilterBedroom(state)
  const {
    isActive,
    isDirectDeal,
    isExternal,
    isNoDeposit,
    isShortTermAvailability,
    isTour,
    isUnavailable,
    isZappable,
  } = listingDetails ?? {}

  return {
    bedroomFilters,
    entity: listingDetails,
    isActive,
    isDirectDeal,
    isExternal,
    isMessaged: isMessaged(state, listingDetails),
    isNoDeposit,
    isShortTermAvailability,
    isTour,
    isUnavailable,
    isZappable,
    mobileView: selectIsMobile(state),
  }
}

export const StickyFormContainer = hocCompose(
  routerConnect(mapRouteToProps, { forwardRouteProps: true }),
  connect(mapStateToProps, {}),
  StickyForm
)
